import { Typography } from "@mui/material";

const PropsPanel = () => <Typography sx={{ color: "text.secondary" }}>TODO: Props settings.</Typography>;

export default PropsPanel;
